import {
  JITMeetAccesoPublicoData,
  JITMeetAccesoPublicoModel,
  JITMeetAccesoValidacionEstado,
} from '../../../../domain/models/jit-meet/jit-meet-acceso-publico.model';
import { JITMeetAccesoPublicoEntity } from '../entities/jit-meet-acceso-publico.entity';

export class JITMeetAccesoPublicoRepositoryMapper {
  mapFrom(entity: JITMeetAccesoPublicoEntity): JITMeetAccesoPublicoModel {
    const data: JITMeetAccesoPublicoData | null = entity.data
      ? {
          ...entity.data,
          estadoValidacion:
            entity.data.estadoValidacion as JITMeetAccesoValidacionEstado,
        }
      : null;

    return {
      data,
      isSuccess: entity.isSuccess,
      message: entity.message,
      showMessage: entity.showMessage,
      errors: entity.errors,
    };
  }
}
